import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { isCandidateProfileEditAtom } from '../atom/candidatesAtom';
import type { CandidateProfileResponse } from '../types/CandidateProfile';
import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import CandidatesProfileCardEdit from './CandidatesProfileCardEdit';
import CandidatesProfileCardDisplay from './CandidatesProfileCardDisplay';

type Props = {
  candidateId: number;
  candidateName: string;
  organizationUsers: { id: number; name: string }[];
  customData: CandidateProfileResponse['custom_data'];
  avatarUrl: string;
  candidateProfileRefetch: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<CandidateProfileResponse, Error>>;
};

/**
 * 求職者プロフィールカード
 * 編集モードと表示モードで別々のコンポーネントをレンダリング
 */
export default function CandidatesProfileCard({
  candidateId,
  candidateName,
  organizationUsers,
  customData,
  avatarUrl,
  candidateProfileRefetch,
}: Props) {
  const [isCandidateProfileEdit, setIsCandidateProfileEdit] = useAtom(isCandidateProfileEditAtom);

  useEffect(() => {
    return () => {
      setIsCandidateProfileEdit(false);
    };
  }, [setIsCandidateProfileEdit]);

  if (isCandidateProfileEdit) {
    return (
      <CandidatesProfileCardEdit
        candidateId={candidateId}
        candidateName={candidateName}
        customData={customData}
        organizationUserIds={organizationUsers.map((u) => u.id)}
        avatarUrl={avatarUrl}
        candidateProfileRefetch={candidateProfileRefetch}
        onEditCancel={() => setIsCandidateProfileEdit(false)}
      />
    );
  }

  return (
    <CandidatesProfileCardDisplay
      candidateName={candidateName}
      avatarUrl={avatarUrl}
      customData={customData}
      onEditClick={() => setIsCandidateProfileEdit(true)}
    />
  );
}
